/*
 * @Descripttion: 客户管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2020-07-06 12:17:06
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @LastEditTime: 2024-01-18 16:08:56
 */
import {
  get,
  post
} from '../index'
export default {
  // 通过手机号搜索用户
  userSelectByPhone (querys) {
    return get('massage/admin/AdminUser/userSelectByPhone', querys)
  },
  // 客户列表
  userList (querys) {
    return get('massage/admin/AdminUser/userList', querys)
  },
  // 编辑成长值
  updateUserGrowth (querys) {
    return post('massage/admin/AdminUser/updateUserGrowth', querys)
  },
  // 拉黑用户｜解除拉黑
  BlockUser (querys) {
    return post('massage/admin/AdminUser/BlockUser', querys)
  },
  // 客户详情
  userInfo (querys) {
    return get('massage/admin/AdminUser/userInfo', querys)
  },
  // 用户评价
  coachCommentUserData (querys) {
    return get('massage/admin/AdminUser/coachCommentUserData', querys)
  },
  // 删除标签
  delUserLabel (querys) {
    return post('massage/admin/AdminUser/delUserLabel', querys)
  },
  // 消费记录
  userOrderList (querys) {
    return get('massage/admin/AdminUser/userOrderList', querys)
  },
  // 成长值明细
  userGrowthList (querys) {
    return get('massage/admin/AdminUser/userGrowthList', querys)
  },
  // 持有优惠券
  userCouponList (querys) {
    return get('massage/admin/AdminUser/userCouponList', querys)
  },
  // 屏蔽技-师
  shieldCoachList (querys) {
    return get('massage/admin/AdminUser/shieldCoachList', querys)
  },
  // 标签列表
  userLabelList (querys) {
    return get('massage/admin/AdminSetting/userLabelList', querys)
  },
  // 标签详情
  userLabelInfo (querys) {
    return get('massage/admin/AdminSetting/userLabelInfo', querys)
  },
  // 新增标签
  userLabelAdd (querys) {
    return post('massage/admin/AdminSetting/userLabelAdd', querys)
  },
  // 编辑标签
  userLabelUpdate (querys) {
    return post('massage/admin/AdminSetting/userLabelUpdate', querys)
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/custom.js